import { useState, useCallback } from 'react';
import { useInterval } from '../useInterval';

/**
 * Производит обратный отсчет времени от `expiryTime` до нуля
 *
 * @param {number} expiryTime - время отсчета в секундах.
 * @param {callback} onExpire - обработчик, который вызывается, когда счетчик достигает нуля.
 * @return {Object}
 *  @param {number} seconds
 *  @param {number} minutes
 *  @param {function} restart
 *  @param {function} start
 */

const DEFAULT_DELAY = 1000;
export const useTimer = (expiryTime = 60, onExpire) => {
  const [milliseconds, setMilliseconds] = useState(expiryTime);
  const [isRunning, setIsRunning] = useState(false);
  const start = useCallback(() => {
    setMilliseconds(expiryTime * 1000);
    setIsRunning(true);
  }, [expiryTime]);
  const restart = useCallback((newExpiryTime = expiryTime) => {
    setMilliseconds(newExpiryTime * 1000);
    setIsRunning(true);
  }, [expiryTime]);
  useInterval(() => {
    const secondsValue = milliseconds - DEFAULT_DELAY;
    setMilliseconds(secondsValue);
    if (secondsValue <= 0) {
      if (onExpire) {
        onExpire();
      }
      setIsRunning(false);
    }
  }, isRunning ? DEFAULT_DELAY : null);
  return {
    minutes: Math.floor(milliseconds / 60000),
    restart,
    seconds: milliseconds / 1000 % 60,
    start
  };
};